// extracted by mini-css-extract-plugin
module.exports = {"summary":"_1gizJ6RW1Rk51zfgNoNbmw","row":"_22zoRujFszQkM0P-ZMk3Ee"};